import type {Lock} from 'services/locks/types';
import type {
  ExpressionV4,
  ManifestationV4,
  WorkV4,
} from 'services/metadata/types';
import type {User} from 'services/users/types';

export enum LockState {
  Initial = 'Initial',
  LockedByOther = 'LockedByOther',
  NotLocked = 'NotLocked',
  /**
   * After acquiring lock or locked by this user in other context (browser tab)
   */
  TemporarilyLocked = 'TemporarilyLocked',
  LockedByThis = 'LockedByThis',
}

export type LockProps = {
  state: LockState;
  lock?: Lock;
  byOtherUser?: User;
  acquireLock: () => Promise<void>;
};

export type WorkMetadataSuggestions = {
  work: Partial<WorkV4>;
  expressions: Array<Partial<ExpressionV4>>;
  manifestations: Array<Partial<ManifestationV4>>;
};
